import { Stack, useTheme } from "@mui/material";
import { useCatalogContext } from "../context/useCatalogContext";
import { EngagedActTypo } from "src/components/Actions/Common/EngagedActTypo";
import { ToggleSwitch } from "@foodpilot/foods";
import { SubgroupBlock } from "./SubgroupBlock";
import { useTranslation } from "react-i18next";

export const SubgroupList = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { currentCatalog, hideAddedActions, setHideAddedActions } = useCatalogContext();

    if (currentCatalog === undefined) {
        return null;
    }

    const subgroups = currentCatalog.subgroups.filter((i) => {
        if (hideAddedActions && i.canHide) {
            return true;
        }
        return false;
    });

    return (
        <Stack
            padding={theme.spacing(2)}
            bgcolor={theme.custom.grey[400]}
            border={`1px solid ${theme.custom.grey[600]}`}
            borderRadius={theme.spacing(1.5)}
            gap={theme.spacing(2)}
        >
            <Stack flexDirection="row" justifyContent={"space-between"} alignItems={"center"}>
                <EngagedActTypo
                    engagedActions={currentCatalog.engagedActions}
                    totalActions={currentCatalog.totalActions}
                />
                <ToggleSwitch
                    label={t("action_plan.hide_added_actions", "Hide engaged actions")}
                    defaultChecked={hideAddedActions}
                    checked={hideAddedActions}
                    onChange={() => {
                        setHideAddedActions(!hideAddedActions);
                    }}
                />
            </Stack>
            <Stack gap={theme.spacing(2)}>
                {subgroups.length === 0 && hideAddedActions && (
                    // It would be a congratulation message
                    <></>
                )}
                {currentCatalog.subgroups.map((group) => {
                    return <SubgroupBlock key={group.id} group={group} parentId={currentCatalog.parent.id} />;
                })}
            </Stack>
        </Stack>
    );
};
